import { Component, OnInit, inject } from '@angular/core';
import { IProcessInstance, IProcessTask } from '@lib/workflow-util';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PurchaseRequisitionWorkflowDataService } from '../service/purchase-requisition-workflow-data.service';
import { IRecord } from '@lib/util';
import {
    DEFAULT_IIM_BPMN_VIEWER_CONFIG,
    IimBpmnHighlight,
    IimBpmnHighlightPosition,
    IimBpmnViewerConfig,
} from '@iim-angular/components';
import { firstValueFrom } from 'rxjs';

export class PurchaseRequisitionProcessDisplayData {
    constructor(public readonly purchaseRequisitionId: string, public readonly purchaseRequisitionNumber: string) {}
}

@Component({
    selector: 'purchase-requisition-process-display',
    templateUrl: './purchase-requisition-process-display.component.html',
    styleUrls: ['./purchase-requisition-process-display.component.scss'],
    standalone: false
})
export class PurchaseRequisitionProcessDisplayComponent implements OnInit {
    readonly dialogRef = inject<MatDialogRef<PurchaseRequisitionProcessDisplayComponent>>(MatDialogRef);
    private readonly workflowDataService = inject(PurchaseRequisitionWorkflowDataService);
    data = inject<PurchaseRequisitionProcessDisplayData>(MAT_DIALOG_DATA);

    public processInstanceIds: IProcessInstance[] = [];
    public xml?: IRecord<string>;
    public highlights: IimBpmnHighlight[] = [];
    public config: IimBpmnViewerConfig = {
        ...DEFAULT_IIM_BPMN_VIEWER_CONFIG,
        canvasDraggable: true,
    };

    ngOnInit(): void {
        this.getData();
    }

    public async getData(): Promise<void> {
        this.processInstanceIds = await firstValueFrom(
            this.workflowDataService.getProcessesFor(this.data.purchaseRequisitionId)
        );
        // In the future it will be possible that we have multiple processes per subject (order/demand).
        // For now we ignore this and simply display the first process.
        if (this.processInstanceIds?.length) {
            this.setHighlights(this.processInstanceIds[0].tasks);
            this.workflowDataService
                .getProcessBpmnXmlForPurchaseRequisition(this.processInstanceIds[0], this.data.purchaseRequisitionId)
                .subscribe((xml: IRecord<string>) => {
                    this.xml = xml;
                });
        }
    }

    private setHighlights(tasks: IProcessTask[]): void {
        if (tasks?.length) {
            const groupedTasks: Map<string, number> = new Map<string, number>();
            tasks.forEach((task) =>
                groupedTasks.set(
                    task.taskDefinitionKey,
                    groupedTasks.has(task.taskDefinitionKey) ? groupedTasks.get(task.taskDefinitionKey)! + 1 : 1
                )
            );
            this.highlights = Array.from(groupedTasks.entries()).map(
                ([key, value]) => new IimBpmnHighlight(key, value, IimBpmnHighlightPosition.TOP_RIGHT_CORNER)
            );
        } else {
            this.highlights = [];
        }
    }
}
